import { render, staticRenderFns } from "./haccpTemplate.vue?vue&type=template&id=24072ac1&scoped=true"
import script from "./haccpTemplate.vue?vue&type=script&lang=js"
export * from "./haccpTemplate.vue?vue&type=script&lang=js"
import style0 from "./haccpTemplate.vue?vue&type=style&index=0&id=24072ac1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24072ac1",
  null
  
)

export default component.exports